
export default {
  'm': {
    'sms_login': "SMS login",
    'get_vercode': "Send",
    'change_mobile': "Change mobile number",
    'log_reg_agree': "Login/Register means agree {msg_ss}",
    'old_mobile': "Original mobile number",
    'new_mobile': "New mobile number",
    'agency_reginfo_fill': "Fill in agency registration information",
    'audit_res': "Audit Result",
    'agency_name': "Agency Name",
    'agency_name_input': "Please enter agency name",
    'agency_name_input_note': "Note: It is recommended that the agency name be short and easy to remember, no more than 30 words.",
    'agency_logo': "AGENCY LOGO",
    'agency_logo_unpload_note': "Please upload a clear logo of your agency, support PNG/JPG/JPEG format.",
    'agency_contact_name': "Agency contact",
    'user_contact_name': "Please fill in the name of the person you contact daily on the user platform",
    'agency_contact_phone': "Agency contact number",
    'agency_whatsapp': "Agent's WhatsApp",
    'agency_whatsapp_contact': "Please enter the agent's WhatsApp contact details.",
    'agency_use_lang': "Language used by the agent",
    'agency_head_ID': "Agent ID",
    'agency_ID_input': "Enter the BuzzCast ID of the agent for later fund release.",
    'reg_country': "Country of registration",
    'inhand_ID_photo': "Photo with ID in hand",
    'upload_note_t': "Note for uploading",
    'agency_self_inhand_ID': "The photo must be taken by the agent himself/herself holding the passport document",
    'photo_must_clearly': "The photo must clearly show the person and the real passport information",
    'mian_form_country': "Main country of origin of streamer",
    'invite_code': "Invitation code",
    'your_profile_submit_success': "Your document has been submitted successfully! we will deal with it as soon as possible. <br>The audit results will be sent to the BuzzCast APP notification of the guild leader, and please pay attention to check!",
    'your_profile_approved': "Your submission was not approved! Reason for rejection: \"Photo with ID in hand is not clear\".<br>Please fill out the form again or contact the official assistant on BuzzCastAPP for more information.",
    'return_refill': "Return to refill",
    'success_agency': "Congratulations on your successful entry into the platform, [click me] to start working!",
    'personal_account': "Personal account",
    'my_agency': "My Agency",
    'your_agency_been_forcibly': "Your agency has been forcibly terminated by the platform, you will no longer be able to log into the system. If you have any questions, please contact BuzzCastAPP official assistant or exclusive operation.",
    'invite_live_join': "Link to invite streamers to join the agency",
    'base_info': "Basic Information",
    'apply_time': "Application time",
    'join_time': "Join time",
    'cooper_status': "Cooperation Status",
    'streamer_manage': "Streamer Management",
    'sereamer_apply': "Streamer Approval",
    'sereamer_nickname': "Streamer nickname",
    'remark': "Remarks",
    'no_remark': "No Remarks",
    'add_remark': "Add a remark",
    'birth': "Year of birth",
    'user_status': "User Status",
    'temporarily_frozen': "Temporarily frozen",
    'permanently_frozen': "Permanently frozen",
    'fans_num': "Number of fans",
    'sign_status': "Signing status",
    'sign_ing': "Under contract",
    'sign_time': "Signing time",
    'release_time': "Release time",
    'live_viola_record': "Live streaming violation record",
    'sign_record': "Signing record",
    'current_contract_status': "Current contract status",
    'termination_reason': "Reason for termination",
    'violation_reason': "Reason for violation",
    'violation_time': "Violation time",
    'processing_result': "Processing result",
    'exported_data': "Exported data",
    'join_agency_apply': "Approval to join the agency",
    'audit_status': "Audit status",
    'pending_review': "Pending review",
    'pending_HQ_review': "Pending HQ review",
    'not_approved_HQ': "Not approved by HQ",
    'withdrawn': "Withdrawn",
    'audit_trail': "Audit trail",
    'oper': "Operation",
    'other_video_materials': "Other video materials",
    'pass': "Pass",
    'pass_streamer_join_agency_apply': "Pass the streamer's application to join the agency",
    'reject_streamer_join_agency_apply': "Reject the streamer's application to join the agency",
    'agree_streamer_join_agency': "Agree streamer {msg_ss1} to join {msg_ss2}",
    'reject_streamer_join_agency': "Deny member {msg_ss1}'s application to join {msg_ss2}",
    'img_material': "Photographic material",
    'approver': "Approver",
    'user_enter_bind_phone': 'Please enter the phone number',
    'vericode': 'Verification code',
    'input_vericode': 'Please enter verification code',
    'login': 'Login',
    'reg': 'Register',
    'logout': 'Sign out',
    'search_for': 'Search',
    'subscription_closed': 'Subscription closed',
    'agency_ID': 'Guild code: {msg_ss}',
    'reset': 'Reset with',
    'live_ID': 'Live broadcast room ID',
    'live_record': 'Live recording screen',
    'email': 'Email Address',
    'phone': 'Phone',
    'mastery_lang': 'Mastery of language',
    'to': 'To',
    'cancel': 'Cancel',
    'Confirm': 'Confirm',
    'preview': 'Preview',
    'rejected': 'Rejected',
    'tip': 'Prompt',
    'i_got_it': 'I got it',
    'cancelled': 'Cancelled',
    'refused': 'Refused',
    'agency_agree': 'The agency has agreed',
    'platform_agree': 'The platform has agreed',
    'user_not_exist': 'This user does not exist',
    'user_frozen': 'The user has been frozen',
    'reviewing': 'Reviewing',
    'review_pass': 'Review passed',
    'review_failed': 'Review failed',
    'xx_hours': '{msg_ss} hours',
    'xx_days': '{msg_ss} days',
    'xx_hour': '{msg_ss} hour',
    'xx_day': '{msg_ss} day',
    'xx_year': '{msg_ss} year',
    'xx_years': '{msg_ss} years',
    'check_phone_istrue': 'Please check if the phone number is correct',
    'male': 'Male',
    'female': 'Female',
    'avatar': 'Portrait',
    'normal': 'Normal',
    'live_room': 'Live room',
    'view': 'View',
    'oper_success': 'Operation succeeded',
    'copy_success': 'Copied',
    'new_mobile_already_reg': 'This new mobile number is already registered',
    'general_user': 'General User',

    'copy': 'Copy',
    'gender': 'Gender',
    'submit': 'Submit',
    'permanent': 'Permanent',
    'agree_agreement': 'Agree and comply with the contracting agreement',
    'vericode_error': 'The verification code is wrong',
    'resend': 'Resend',
    'approved': 'Approved',
    'not_approved': 'Not approved',
    'agency_rejected': 'Platform has rejected',
    'select': 'Select',
    'search': 'Search',
    'rejection_reason': 'Reason for rejection',
    'no_data': 'No data',
    'oper_failed': 'The operation failed',
    'leave_agency_apply': 'Approval to leave the agency',
    'over_word_limit': 'Go over the word limit.',
    'delete': 'Delete',
    'nickname': 'Nickname',
    'file_is_too_large': 'Too large file',

    'community_convention': 'Buzzcast Community Convention',
    'approval_time': 'Approval Time',
    'guild_system_title': 'BuzzCast Social Platform Guild System',
    'return': 'Return',
    'img_upload_fail': 'Image Upload Failed',
    'cooper_ing': 'Cooperation in progress',
    'upload_file_format_incorrect': 'The uploaded file is not in the correct format',
    'token_invalid': 'Token is invalid, please log in again!',
    'network_busy': 'The network is busy, please try again',
    'minute': '{msg_ss}minute',

    'live_room_ID': 'Live broadcasting room ID',

    'scan_code': 'Scan the code to login',
    'open_code': 'Open the app and click my QR code to scan',
    'refresh': 'Refresh',
    'login_confirm': 'The login confirmation',
    'account': 'Account information',
    'user_name': 'User name',
    'edit': 'Modification',
    'changing': 'Changing the Binding Number',
    'mobile_number': 'Mobile phone account number',
    'mobile_login': 'You can log in using your mobile phone number {msg_ss}',
    'appId_login': 'You can use account App ID 【{msg_ss}】to scan for log in',
    'code_login': 'The BuzzCastApp ID is not bound, you can scan the QR code to log in afyer binding',
    'verification_log': 'You can use the mobile phone number and verification to log in if mo mobile phone number is bound',
    'binding_success': 'Binding success',
    'binding_mobile': 'Binding mobile phone number',
    'edit_name': 'Change a user name',
    'binding_alert': 'Reminder of binding change',
    'new_appId': 'The original APP ID will be directly replaced if the new APP ID is used to scan the binding code',
    'binding_account': 'Binding the BuzzCast App account',
    'anchor_earings': 'The anchor\'s earings',
    'signing_date': 'Signing date',
    'statistical_date': 'The statistical date',
    'valid_min': 'Total valid number (min)',
    'valid_day': 'The validity period in days',
    'total_revenue': 'Total revenue',

    'bind': 'Bind',
    'please_agree_agree': 'Please agree to the agreement',
    'note': 'Note: The time shown in this syst',
    'app_phone': 'Register the mobile phone number of the APP',
    'host_num': 'Number of host',
    'enter_host_num': 'Please enter its number of all host',
    'platform': 'Cooperation platform',
    'statement': 'Monthly bank statement',
    'enter_income': 'Please enter the average monthly income',
    'check_commas': 'Incorrect format. Please check whether the multiple platforms are separated by commas',
    'submit_success': 'Your document has been submitted successfully! we will deal with it as soon as possible',
    'usd': 'USD',
    'many_platforms': 'Please enter the live broadcast platform you have cooperated with before, up to 20 platforms',
    'limit_platform': 'Up to 20 platforms',
    'user_has_delete': 'This user has been cancelled',
    'cant_commit': 'You are already a contracted broadcaster, and you cannot apply for a guild to settle in at the same time',
    'cant_commit_1': 'You have already applied a contracted broadcaster, and you cannot apply for a guild to settle in at the same time',
    'passwd': 'Password',
    'passwd_placeholder': 'Your password should contain 6 to 20 characters',
    'live_rights': 'Time-free assessment',
    'edit_log': 'Change record',
    'edit_time': 'Change the time',
    'edit_pwd': 'Change password',
    'old_pwd': 'Old password',
    'new_pwd': 'New Password',
    'confirm_pwd': 'Confirm Password',
    'forget_pwd': 'Forget password?',
    'email_check': 'Email format is incorrect',
    'phone_pwd_error': 'Incorrect Phone Number or Password',
    'ten_min_error': 'Please try again in 10 minutes',
    'phone_bind_error': 'The mobile phone number has been linked to another account, please use a new mobile phone number to try it again.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'The guild leader ID has already been filled in, please fill in again',
    'pwd_error': 'Password error',
    'phone_not_reg_error': 'The account is not registered till now',
    'pwd_nq': 'Password is inconsistent with the previous one',
    'sign_anchor_error': 'You are already a contracted broadcaster, and you cannot apply for a guild to settle in at the same time',
    'apply_anchor_error': 'You have already applied a contracted broadcaster, and you cannot apply for a guild to settle in at the same time',
    'have-expired': 'Expired',
    'approval-time': 'Approval time',
    'reasons-for-refusal': 'Please enter a reason for refusal',
    'Transfer-grounds': 'Transfer reason',
    'code_expire': 'The verification code has expired, please click the verification code to refresh',
    'transfer-approval': 'Transfer approval',
    'live_state_placeholder': 'Broadcast status',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Banned',
    'live_state_forever_banned': 'Permanently banned',
    'live_allowed_time': 'Time allowed to start streaming',
    'live_banned_time': 'Ban period',
    'deduct_money': 'Deduct the amount of B coins',
    'final_income': 'Real gains',
    'select_start_dt': 'Please select a start time',
    'select_end_dt': 'Please select an end time',
    'less_then_end_dt': 'The start time must be less than or equal to the end time',
    'System_automatically_through': 'System automatically through',
    'btrade_err': 'The agency ID is not available',

    'mouth_anchor': 'Monthly salary host',
    'day_anchor': 'Daily salary host',
    'guild_anchor': 'Agent commission (daily salary policy)',
    'mouth_anchor_st': 'Monthly salary start time',
    'mouth_anchor_et': 'Monthly salary end time',
    'day_anchor_st': 'Daily salary start time',
    'day_anchor_et': 'Daily salary end time',
    'all_award_bcoin': 'Daily salary total income',
    'live_hour': 'Valid duration reward',
    'salary_day': 'Date',
    'day_in_come': 'Agency revenue for the day (Valid Bcoins)',
    'award_ration_flag_str': 'Reward ratio',
    'payable_money': "Agent's Bcoins Rewards",
    'host_bcoins': 'Bcoins earnings of host',
    'total_official': 'Total number of Bcoins awarded by the official',
    'actual_bcoins_awarded': 'Actual Bcoins awarded',
    "change_bound_account":"Change bound account" ,
    "agent_id_form":"Agent ID:" ,
    "BuzzCast_verification_code":"BuzzCast verification code:" ,
    "send_success":"Send successfully" ,
    "account_changed_successfully":"The bound account was changed successfully." ,
    "invite_guild_url":"Invite to become the BuzzCast agent link: {msg_ss}" ,
    "invite_guild_code":"My invitation code: {msg_ss}" ,
    "save":"Save" ,
    "compile":"Edit" ,
    "agent_nvitation_eward":"Agent Invitation Reward" ,
    "agent_name":"Agent name" ,
    "guild_id":"Agency Code" ,
    "guild_income_30days":"Agency income in the past 30 days" ,
    "guild_invite_income_30days":"Agency invitation income in the past 30 days" ,
    "agency_commission_ratio":"Agency Commission Ratio" ,
    "invite_income_bcoins":"Invitation reward B coin" ,
    "id_not_exist":"The ID does not exist" ,
    "reward_distribution_status":"Reward Distribution Status" ,
    'must_number': 'The content you enter must be in numeric format only.',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js